import type { Activity, Statement } from "@xapi/xapi";
import type { AdaptiveTestDiagnosis } from "../../interfaces/AdaptiveTestDashboard";
import { XAPI_REGISTRY } from "./const";

export const extractAdaptiveTestDiag = (
  statement: Statement,
): AdaptiveTestDiagnosis | undefined => {
  const diag: AdaptiveTestDiagnosis = statement.result?.extensions?.[
    `${XAPI_REGISTRY}/extensions/adaptive-test-diagnosis`
  ] as AdaptiveTestDiagnosis;
  if (!statement.id || !diag) {
    throw new Error("Error extracting adaptiv test diagnosis");
  }
  return {
    ...diag,
    eventId: statement.id,
  };
};

export const getStatementEntryLearningSetId = (
  statement: Statement,
): string | undefined =>
  statement.context?.contextActivities?.parent
    ?.find((parent) => parent.id.startsWith(`${XAPI_REGISTRY}/learning-set/`))
    ?.id.split("/")
    .reverse()[0];

export const getExerciseId = (statement: Statement): string | undefined =>
  (statement.object as Activity).id.split("/").reverse()[0];
